import React, { useState, useEffect } from "react";
import { timeDiffCalc } from "utils/utils";
import { useUser } from "reactfire";
import { query, doc, collection, limit } from "firebase/firestore";
import { useLeague } from "context/leagueContext";
import { useTranslation } from "react-i18next";

import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import RoundTab from "components/roundTab";

const SpecialTab = ({ roundData, id, isPassed }) => {
  const {
    state: { leagueInfo, nextRoundId, leagueUserData },
  } = useLeague();

  const { status, data: user } = useUser();
  const { t } = useTranslation();
  const firestore = useFirestore();
  const [userRoundData, setUserRoundData] = useState(undefined);
  const [roundInfo, setRoundInfo] = useState(undefined);
  const [roundPick, setRoundPick] = useState(undefined);

  /* 
  Get user info for league.
   */
  const userRoundDataRef = doc(
    firestore,
    "userTournaments/" +
      leagueInfo?.id +
      "/rounds/" +
      roundData?.id +
      "/users/",
    user?.uid
  );
  const { status: userLeagueDataStatus, data: userRoundDataDoc } =
    useFirestoreDocData(userRoundDataRef);
  useEffect(() => {
    if (userRoundDataDoc) {
      setUserRoundData(userRoundDataDoc);
    }
  }, [userRoundDataDoc]);

  /* 
  Get round info
   */
  const roundInfoRef = doc(
    firestore,
    "userTournaments/" + leagueInfo?.id + "/rounds/",
    roundData?.id
  );
  const { status: roundInfoStatus, data: roundInfoDoc } =
    useFirestoreDocData(roundInfoRef);
  useEffect(() => {
    if (roundInfoDoc) {
      setRoundInfo(roundInfoDoc);
    }
  }, [roundInfoDoc]);

  let tabPlayers;
  let totalCount = leagueInfo?.userCount ? leagueInfo?.userCount : 0;
  let eleminatedCount = leagueInfo?.eliminatedCount
    ? leagueInfo?.eliminatedCount
    : 0;
  let passedRoundCount = roundInfo?.usersPassedRound
    ? roundInfo?.usersPassedRound
    : 0;
  let exitedRoundCount = roundInfo?.usersExitedRound
    ? roundInfo?.usersExitedRound
    : 0;

  if (id == 0) {
    tabPlayers = totalCount;
  } else if (nextRoundId && nextRoundId === roundData?.id) {
    tabPlayers = totalCount - eleminatedCount;
  } else if (roundData?.settled) {
    tabPlayers = passedRoundCount + exitedRoundCount;
  }

  /* 
  LMS find user pick for round.
   */
  const roundEventsCollection = collection(
    firestore,
    "userTournaments/" +
      leagueInfo?.id +
      "/rounds/" +
      roundData?.id +
      "/users/" +
      user?.uid +
      "/events"
  );
  const roundEventsQuery = query(roundEventsCollection, limit(1));
  const { status: roundEventsStatus, data: roundEvents } =
    useFirestoreCollectionData(roundEventsQuery, {
      idField: "id",
    });
  useEffect(() => {
    if (roundEvents && roundEvents[0]) {
      setRoundPick(roundEvents[0]);
    } else {
      setRoundPick(undefined);
    }
  }, [roundEvents]);

  let time = timeDiffCalc(
    new Date(roundData?.deadline?.seconds * 1000),
    new Date().getTime()
  );
  let roundName = t("tournament.roundtab.round") + " " + (roundData?.pos + 1);

  let labelStatus, label, roundContent;
  roundContent = tabPlayers !== undefined ? tabPlayers : null;

  if (roundPick?.team) {
    label = roundPick?.team;
  } else if (roundData?.settled) {
    label = t("tournament.roundtab.settled");
  } else if (time) {
    label = time;
  } else {
    label = t("tournament.roundtab.ongoing");
  }

  if (userRoundData?.points == 1) {
    labelStatus = 1;
  } else if (
    userRoundData?.points == 0 &&
    leagueUserData?.exitRound !== roundData?.id
  ) {
    labelStatus = null;
  } else {
    labelStatus = 3;
  }

  return (
    <RoundTab
      id={roundData?.id}
      header={roundName}
      title={roundContent}
      subTitle={t("lobby.card.players", {
        count: 2,
      })}
      label={label}
      settled={roundData?.settled}
      highlighted={nextRoundId === roundData?.id}
      labelStatus={labelStatus}
    />
  );
};

export default SpecialTab;
